import { render } from "./StockTurnover.vue?vue&type=template&id=7dc8e411"
import script from "./StockTurnover.vue?vue&type=script&lang=js"
export * from "./StockTurnover.vue?vue&type=script&lang=js"
script.render = render

export default script